import { WebPaths } from '@griply/types';

// Routes a signed-out user lands on. The Electron shell refuses to open the create-task popover on these.
export const AUTH_PATHS: ReadonlySet<WebPaths> = new Set([
  WebPaths.Login,
  WebPaths.Signup,
  WebPaths.ForgotPassword,
  WebPaths.ResetPassword,
  WebPaths.CompleteSignup,
  WebPaths.VerifyEmail,
]);
